export default __webpack_public_path__ + "static/media/DnDcartoonbook1.13bf0c9e.jpg";